/* istanbul ignore file */
import { FormSection, MediumFormRow } from 'framework/ui/layout';
import { EnumDropdown, ClearAfterUnmountWrapper } from 'framework/form';
import { AccountNameInput as AccountInput } from 'domain/shared/account';
import LeadSearchInput from 'domain/sales/lead/shared/input/LeadSearchInput';
import { ACCOUNT_PATH } from 'domain/shared/account';
import { useAccountId } from 'domain/sales/account/accountRouting';
import { useOpportunityId } from 'domain/shared/opportunity';
import OpportunitySearchInput from 'domain/sales/opportunity/shared/input/OpportunitySearchInput';
import { useLocation } from 'react-router-dom';
import { useLeadId } from 'domain/sales/lead/leadRouting';
import { ENTITY_TYPE, ENTITY_TYPE_ALIAS } from 'domain/sales/shared/timeline/activity/shared/transferActivityService';
import { LEADS_PATH } from 'domain/shared/lead';
import { OPPORTUNITY_PATH } from 'domain/shared/core/sharedRouteConstants';

const TransferActivityFormSection = () => {
  const location = useLocation();
  const rawLeadId = useLeadId();
  const currentLeadId = location?.pathname?.includes(LEADS_PATH) ? rawLeadId : null;
  const rawAccountId = useAccountId();
  const currentAccountId = location?.pathname?.includes(ACCOUNT_PATH) ? rawAccountId : null;
  const rawOpportunityId = useOpportunityId();
  const currentOpportunityId = location?.pathname?.includes(OPPORTUNITY_PATH) ? rawOpportunityId : null;
  const leadFilter = currentLeadId
    ? {
        id: {
          ne: currentLeadId,
        },
      }
    : {};
  const accountFilter = currentAccountId
    ? {
        alias: {
          ne: currentAccountId,
        },
      }
    : {};
  const opportunityFilter = currentOpportunityId
    ? {
        id: {
          ne: currentOpportunityId,
        },
      }
    : {};

  return (
    <>
      <FormSection>
        <MediumFormRow>
          <EnumDropdown options={ENTITY_TYPE} source="entityType" placeholder="Select..." className="input-group" />
        </MediumFormRow>
        <MediumFormRow>
          <ClearAfterUnmountWrapper isVisible={data => data.entityType === ENTITY_TYPE_ALIAS.ACCOUNT}>
            <AccountInput
              source="accountId"
              label="Target Account"
              defaultFilter={accountFilter}
              customMapResponse={account => {
                return {
                  accountId: account.accountId,
                  text: account.accountName,
                };
              }}
            />
          </ClearAfterUnmountWrapper>
        </MediumFormRow>
        <MediumFormRow>
          <ClearAfterUnmountWrapper isVisible={data => data.entityType === ENTITY_TYPE_ALIAS.LEAD}>
            <LeadSearchInput source="leadId" label="Target Lead" defaultFilter={leadFilter} />
          </ClearAfterUnmountWrapper>
        </MediumFormRow>
        <MediumFormRow>
          <ClearAfterUnmountWrapper isVisible={data => data.entityType === ENTITY_TYPE_ALIAS.OPPORTUNITY}>
            <OpportunitySearchInput
              source="opportunityId"
              label="Target Opportunity"
              defaultFilter={opportunityFilter}
            />
          </ClearAfterUnmountWrapper>
        </MediumFormRow>
      </FormSection>
    </>
  );
};

export default TransferActivityFormSection;
